import { FETCH_PRODUCT_IMAGE } from "../actions/types";

export const productImageReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_IMAGE:
      return action.payload;
    default:
      return state;
  }
};
